import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyAil5naM9mSHK_hgYXOJoU1mCK7jqtBQmQ',
  authDomain: 'qc-workspace.firebaseapp.com',
  projectId: 'qc-workspace',
  storageBucket: 'qc-workspace.firebasestorage.app',
  messagingSenderId: '677348858330',
  appId: '1:677348858330:web:54849ce189d1fce45308e3',
  measurementId: 'G-PT187VYD51'
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
